import { Component, Inject, OnInit } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { RfAuthenticationService } from "src/app/authentication/rf-authentication.service";
import { CsManagementService } from "src/app/shared/service/store-management/cs-management/cs-management.service";
import { BaseComponent } from "../../../base/base.component";
import { CSModel } from "./model/cs.model";
import { CustomerChooseService } from "./service/customer-choose.service";
import { TitleWidgetComponent } from "../../../heading-widget/title-widget/title-widget.component";
import { MaterialModule } from "src/app/shared/module/material.module";
import { I18nPipe } from "src/app/shared/i18n/pipe/i18n.pipe";
import { CommonModule } from "@angular/common";
import { CustomerTableComponent } from "./customer-table/customer-table.component";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector: "ald-customer-choose",
    templateUrl: "./customer-choose.component.html",
    styleUrls: ["./customer-choose.component.scss"],
    imports: [
        TitleWidgetComponent,
        MaterialModule,
        I18nPipe,
        CommonModule,
        CustomerTableComponent,
        ReactiveFormsModule,
        FormsModule
    ]
})
export class CustomerChooseComponent extends BaseComponent implements OnInit {
  closable = false;
  csForm: UntypedFormGroup;
  customerRefIdSelected: number;
  validate;
  cSModelRetrieved: CSModel;
  inputValue: number;
  constructor(
    private customerChooseService: CustomerChooseService,
    private csmanagementService: CsManagementService,
    public dialogRef: MatDialogRef<CustomerChooseComponent>,
    public authService: RfAuthenticationService,
    @Inject(MAT_DIALOG_DATA) public data,
    private _fb: UntypedFormBuilder
  ) {
    super();
    this.dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.intForm();
    this.customerRefIdValueChanges();
  }

  reset(){
    this.cSModelRetrieved = null
  }

  intForm() {
    this.csForm = this._fb.group({
      customerRefId: ["", Validators.required],
    });
  }

  customerRefIdValueChanges() {
    this.valueChanges(this.csForm, "customerRefId").subscribe(
      (customerRefIdValueChanged) => {
        this.customerRefIdSelected = customerRefIdValueChanged;
      }
    );
  }

  onClose(): void {
    this.dialogRef.close();
  }

  selectedCs(csSelected) {
    this.dialogRef.close(csSelected);
  }

  onLogout(): void {
    this.authService.logout();
    this.dialogRef.close();
  }

  onSubmit(): void {
    this.customerChooseService
      .checkIfCustomerIsValid(this.customerRefIdSelected)
      .subscribe((checkCustomer: CSModel) => {
        this.cSModelRetrieved = checkCustomer;
        this.csmanagementService.setCustomerServiceInStore(checkCustomer);
      });
  }

  isInputEmpty(): boolean {
    return this.inputValue === null || isNaN(this.inputValue);
  }
}
